import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { BarChart } from '@mui/x-charts';

const getMonthlySeriesData = (data) => {
    const series = data?.map((e) => ({
        dataKey: e.month,
        label: e.month,
    }))
    return series?.reverse();
}

const getMonthlyDataset = (data) => {
    const dataset = data?.map((e) => {
        var object = e.data.reduce(
            (obj, item) => Object.assign(obj, { [item.month]: item.count }), {}
        );
        return {
            ...object,
            name: e.name,
        }
    })
    return dataset;
}

function RoomNightSalesComparisonMonthly({ data, colors }) {
    const theme = useTheme();
    const smScreen = useMediaQuery(theme.breakpoints.up("sm"));
    const series = getMonthlySeriesData(data[0]?.data);
    const dataSet = getMonthlyDataset(data)

    return (
        <Box backgroundColor={colors.primary[400]} p="20px">
            <Typography variant="h5">
                ROOM NIGHT SALES COMPARISON
            </Typography>
            <Typography variant="h4" fontWeight="600" textTransform={"uppercase"}>
                WITH PREVIOUS MONTHS
            </Typography>
            {data?.length ? (
                <Box
                    width={"100%"}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    mt={1}
                    // ml={4}
                >
                    <BarChart
                        dataset={dataSet}
                        // colors={["yellow", "lightgreen"]}
                        xAxis={[{ scaleType: 'band', dataKey: 'name' }]}
                        series={series}
                        {...{width: smScreen ? 800 : 500, height: 300}}
                    />
                </Box>
            ) : (
                <Typography mt={15} mb={15} textAlign="center">
                    No Data Available...
                </Typography>
            )}
        </Box>
    )
}

export default RoomNightSalesComparisonMonthly;